export enum NotificationTypeEnum {
    Call = "call",
    Text = "Text"
}